/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type {
  OffsetDateTime,
  LocalDate,
} from "@freightsimple/time/branded-types";

import { mapValues } from "../runtime";
import type { CurrencyCode } from "./CurrencyCode";
import {
  CurrencyCodeFromJSON,
  CurrencyCodeFromJSONTyped,
  CurrencyCodeToJSON,
  CurrencyCodeToJSONTyped,
} from "./CurrencyCode";
import type { CompanyTemperature } from "./CompanyTemperature";
import {
  CompanyTemperatureFromJSON,
  CompanyTemperatureFromJSONTyped,
  CompanyTemperatureToJSON,
  CompanyTemperatureToJSONTyped,
} from "./CompanyTemperature";
import type { SalesPipelineStage } from "./SalesPipelineStage";
import {
  SalesPipelineStageFromJSON,
  SalesPipelineStageFromJSONTyped,
  SalesPipelineStageToJSON,
  SalesPipelineStageToJSONTyped,
} from "./SalesPipelineStage";
import type { ControlsLtlFreight } from "./ControlsLtlFreight";
import {
  ControlsLtlFreightFromJSON,
  ControlsLtlFreightFromJSONTyped,
  ControlsLtlFreightToJSON,
  ControlsLtlFreightToJSONTyped,
} from "./ControlsLtlFreight";
import type { PaymentMethod } from "./PaymentMethod";
import {
  PaymentMethodFromJSON,
  PaymentMethodFromJSONTyped,
  PaymentMethodToJSON,
  PaymentMethodToJSONTyped,
} from "./PaymentMethod";
import type { CountryCode } from "./CountryCode";
import {
  CountryCodeFromJSON,
  CountryCodeFromJSONTyped,
  CountryCodeToJSON,
  CountryCodeToJSONTyped,
} from "./CountryCode";
import type { BookingEngagement } from "./BookingEngagement";
import {
  BookingEngagementFromJSON,
  BookingEngagementFromJSONTyped,
  BookingEngagementToJSON,
  BookingEngagementToJSONTyped,
} from "./BookingEngagement";

/**
 *
 * @export
 * @interface Company
 */
export interface Company {
  /**
   *
   * @type {string}
   * @memberof Company
   */
  companyId?: string;
  /**
   *
   * @type {OffsetDateTime}
   * @memberof Company
   */
  createdAt?: OffsetDateTime;
  /**
   *
   * @type {string}
   * @memberof Company
   */
  companyName?: string;
  /**
   *
   * @type {string}
   * @memberof Company
   */
  stripeCustomerId?: string;
  /**
   *
   * @type {string}
   * @memberof Company
   */
  addCreditCardAuthorizationId?: string;
  /**
   *
   * @type {number}
   * @memberof Company
   */
  discountPercentage?: number;
  /**
   *
   * @type {boolean}
   * @memberof Company
   */
  forTest?: boolean;
  /**
   *
   * @type {string}
   * @memberof Company
   */
  preferredBrokerNorthbound?: string;
  /**
   *
   * @type {string}
   * @memberof Company
   */
  preferredBrokerSouthbound?: string;
  /**
   *
   * @type {string}
   * @memberof Company
   */
  defaultPickupLocation?: string;
  /**
   *
   * @type {string}
   * @memberof Company
   */
  defaultDeliveryLocation?: string;
  /**
   *
   * @type {string}
   * @memberof Company
   */
  utmSource?: string;
  /**
   *
   * @type {string}
   * @memberof Company
   */
  utmMedium?: string;
  /**
   *
   * @type {string}
   * @memberof Company
   */
  utmCampaignId?: string;
  /**
   *
   * @type {string}
   * @memberof Company
   */
  shipmentFrequency?: string;
  /**
   *
   * @type {boolean}
   * @memberof Company
   */
  quotingDisabled?: boolean;
  /**
   *
   * @type {number}
   * @memberof Company
   */
  paymentTermsDays?: number;
  /**
   *
   * @type {string}
   * @memberof Company
   */
  leadSource?: string;
  /**
   *
   * @type {CompanyTemperature}
   * @memberof Company
   */
  temperature?: CompanyTemperature;
  /**
   *
   * @type {number}
   * @memberof Company
   */
  creditLimit?: number;
  /**
   *
   * @type {string}
   * @memberof Company
   */
  referralCode?: string;
  /**
   *
   * @type {boolean}
   * @memberof Company
   */
  chequePaymentMethodPermitted?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof Company
   */
  wirePaymentMethodPermitted?: boolean;
  /**
   *
   * @type {number}
   * @memberof Company
   */
  quotesRan?: number;
  /**
   *
   * @type {LocalDate}
   * @memberof Company
   */
  lastQuotedDate?: LocalDate;
  /**
   *
   * @type {number}
   * @memberof Company
   */
  shipmentsBooked?: number;
  /**
   *
   * @type {LocalDate}
   * @memberof Company
   */
  lastBookedDate?: LocalDate;
  /**
   *
   * @type {number}
   * @memberof Company
   */
  winRate?: number;
  /**
   *
   * @type {number}
   * @memberof Company
   */
  totalCadSales?: number;
  /**
   *
   * @type {number}
   * @memberof Company
   */
  fixedMarkup?: number;
  /**
   *
   * @type {boolean}
   * @memberof Company
   */
  doNotAutochargeOverdueInvoices?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof Company
   */
  needsVerification?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof Company
   */
  verificationDenied?: boolean;
  /**
   *
   * @type {CurrencyCode}
   * @memberof Company
   */
  currency?: CurrencyCode;
  /**
   *
   * @type {boolean}
   * @memberof Company
   */
  isPersonal?: boolean;
  /**
   *
   * @type {string}
   * @memberof Company
   */
  phone?: string;
  /**
   *
   * @type {number}
   * @memberof Company
   */
  billingLatitude?: number;
  /**
   *
   * @type {number}
   * @memberof Company
   */
  billingLongitude?: number;
  /**
   *
   * @type {string}
   * @memberof Company
   */
  billingAddressLine?: string;
  /**
   *
   * @type {string}
   * @memberof Company
   */
  billingCity?: string;
  /**
   *
   * @type {string}
   * @memberof Company
   */
  billingState?: string;
  /**
   *
   * @type {string}
   * @memberof Company
   */
  billingPostalCode?: string;
  /**
   *
   * @type {string}
   * @memberof Company
   */
  defaultSalesContactId?: string;
  /**
   *
   * @type {CountryCode}
   * @memberof Company
   */
  billingCountry?: CountryCode;
  /**
   *
   * @type {LocalDate}
   * @memberof Company
   */
  lastSignificantSalesCallDate?: LocalDate;
  /**
   *
   * @type {LocalDate}
   * @memberof Company
   */
  lastSalesCallDate?: LocalDate;
  /**
   *
   * @type {ControlsLtlFreight}
   * @memberof Company
   */
  controlsLtlFreight?: ControlsLtlFreight;
  /**
   *
   * @type {LocalDate}
   * @memberof Company
   */
  snoozeSalesCallsUntil?: LocalDate;
  /**
   *
   * @type {Array<string>}
   * @memberof Company
   */
  associatedProfessionalDomain?: Array<string>;
  /**
   *
   * @type {boolean}
   * @memberof Company
   */
  hasNonProfessionalDomain?: boolean;
  /**
   *
   * @type {Array<string>}
   * @memberof Company
   */
  knownGroupEmailAddresses?: Array<string>;
  /**
   *
   * @type {string}
   * @memberof Company
   */
  referralCompanyId?: string;
  /**
   *
   * @type {string}
   * @memberof Company
   */
  referralShipmentId?: string;
  /**
   *
   * @type {LocalDate}
   * @memberof Company
   */
  firstQuoteDate?: LocalDate;
  /**
   *
   * @type {boolean}
   * @memberof Company
   */
  isBroker?: boolean;
  /**
   *
   * @type {LocalDate}
   * @memberof Company
   */
  firstBookedDate?: LocalDate;
  /**
   *
   * @type {string}
   * @memberof Company
   */
  lastSignificantSalesCallBy?: string;
  /**
   *
   * @type {string}
   * @memberof Company
   */
  lastSalesCallBy?: string;
  /**
   *
   * @type {string}
   * @memberof Company
   */
  gclid?: string;
  /**
   *
   * @type {string}
   * @memberof Company
   */
  utmTerm?: string;
  /**
   *
   * @type {string}
   * @memberof Company
   */
  invoiceAuditNotes?: string;
  /**
   *
   * @type {boolean}
   * @memberof Company
   */
  apiAccessEnabled?: boolean;
  /**
   *
   * @type {number}
   * @memberof Company
   */
  numberOfSalesCalls?: number;
  /**
   *
   * @type {number}
   * @memberof Company
   */
  numberOfSignificantSalesCalls?: number;
  /**
   *
   * @type {string}
   * @memberof Company
   */
  shipmentFrequencyOnSignup?: string;
  /**
   *
   * @type {number}
   * @memberof Company
   */
  totalOverdueIssuedInvoices?: number;
  /**
   *
   * @type {number}
   * @memberof Company
   */
  totalIssuedInvoices?: number;
  /**
   *
   * @type {number}
   * @memberof Company
   */
  totalDisputedInvoices?: number;
  /**
   *
   * @type {number}
   * @memberof Company
   */
  totalSettlementPendingInvoices?: number;
  /**
   *
   * @type {string}
   * @memberof Company
   */
  utmContent?: string;
  /**
   *
   * @type {string}
   * @memberof Company
   */
  utmCampaignName?: string;
  /**
   *
   * @type {string}
   * @memberof Company
   */
  msclkid?: string;
  /**
   *
   * @type {PaymentMethod}
   * @memberof Company
   */
  preferredPaymentMethod?: PaymentMethod;
  /**
   *
   * @type {string}
   * @memberof Company
   */
  preferredPaymentMethodNotes?: string;
  /**
   *
   * @type {number}
   * @memberof Company
   */
  totalCadProfit?: number;
  /**
   *
   * @type {number}
   * @memberof Company
   */
  averageQuoteQualityScore?: number;
  /**
   *
   * @type {string}
   * @memberof Company
   */
  networkId?: string;
  /**
   *
   * @type {LocalDate}
   * @memberof Company
   */
  lastClaimDate?: LocalDate;
  /**
   *
   * @type {number}
   * @memberof Company
   */
  numberClaimShipments?: number;
  /**
   *
   * @type {LocalDate}
   * @memberof Company
   */
  lastAdditionalChargeDate?: LocalDate;
  /**
   *
   * @type {number}
   * @memberof Company
   */
  numberAdditionalChargeShipments?: number;
  /**
   *
   * @type {number}
   * @memberof Company
   */
  numberInvoiceAuditProblemShipments?: number;
  /**
   *
   * @type {boolean}
   * @memberof Company
   */
  customerSpecificPricingEnabled?: boolean;
  /**
   *
   * @type {string}
   * @memberof Company
   */
  leadSourceNote?: string;
  /**
   *
   * @type {string}
   * @memberof Company
   */
  assignedTo?: string;
  /**
   *
   * @type {OffsetDateTime}
   * @memberof Company
   */
  assignedAt?: OffsetDateTime;
  /**
   *
   * @type {SalesPipelineStage}
   * @memberof Company
   */
  currentSalesPipelineStage?: SalesPipelineStage;
  /**
   *
   * @type {OffsetDateTime}
   * @memberof Company
   */
  salesPipelineEnteredStageNeverQuotedAt?: OffsetDateTime;
  /**
   *
   * @type {OffsetDateTime}
   * @memberof Company
   */
  salesPipelineEnteredStageQuotedNeverBookedAt?: OffsetDateTime;
  /**
   *
   * @type {OffsetDateTime}
   * @memberof Company
   */
  salesPipelineEnteredStageBooked1To4At?: OffsetDateTime;
  /**
   *
   * @type {OffsetDateTime}
   * @memberof Company
   */
  salesPipelineEnteredStageRegularShipperAt?: OffsetDateTime;
  /**
   *
   * @type {number}
   * @memberof Company
   */
  estimatedMonthlyFreightSpend?: number;
  /**
   *
   * @type {boolean}
   * @memberof Company
   */
  overdueCall?: boolean;
  /**
   *
   * @type {number}
   * @memberof Company
   */
  monthlyLtlCaptureEstimate?: number;
  /**
   *
   * @type {string}
   * @memberof Company
   */
  salesPipelineEnteredStageNeverQuotedAssignedTo?: string;
  /**
   *
   * @type {string}
   * @memberof Company
   */
  salesPipelineEnteredStageQuotedNeverBookedAssignedTo?: string;
  /**
   *
   * @type {string}
   * @memberof Company
   */
  salesPipelineEnteredStageBooked1To4AssignedTo?: string;
  /**
   *
   * @type {string}
   * @memberof Company
   */
  salesPipelineEnteredStageRegularShipperAssignedTo?: string;
  /**
   *
   * @type {number}
   * @memberof Company
   */
  additionalChargeGracePeriodDaysOverride?: number;
  /**
   *
   * @type {string}
   * @memberof Company
   */
  xeroContactId?: string;
  /**
   *
   * @type {string}
   * @memberof Company
   */
  bannerMessageTitle?: string;
  /**
   *
   * @type {string}
   * @memberof Company
   */
  bannerMessageDescription?: string;
  /**
   *
   * @type {string}
   * @memberof Company
   */
  bannerMessageLastEditedBy?: string;
  /**
   *
   * @type {OffsetDateTime}
   * @memberof Company
   */
  bannerMessageLastEditedAt?: OffsetDateTime;
  /**
   *
   * @type {number}
   * @memberof Company
   */
  estimatedMonthlyShipments?: number;
  /**
   *
   * @type {string}
   * @memberof Company
   */
  shipmentFrequencyNote?: string;
  /**
   *
   * @type {string}
   * @memberof Company
   */
  cspProposalEmailDraft?: string;
  /**
   *
   * @type {string}
   * @memberof Company
   */
  referrer?: string;
  /**
   *
   * @type {string}
   * @memberof Company
   */
  landingPage?: string;
  /**
   *
   * @type {string}
   * @memberof Company
   */
  firstTouchReferrer?: string;
  /**
   *
   * @type {string}
   * @memberof Company
   */
  firstTouchLandingPage?: string;
  /**
   *
   * @type {BookingEngagement}
   * @memberof Company
   */
  currentBookingEngagement?: BookingEngagement;
  /**
   *
   * @type {number}
   * @memberof Company
   */
  bookingAvgGapDays?: number;
  /**
   *
   * @type {number}
   * @memberof Company
   */
  daysSinceLastBooking?: number;
  /**
   *
   * @type {number}
   * @memberof Company
   */
  bookingOverdueRatio?: number;
  /**
   *
   * @type {OffsetDateTime}
   * @memberof Company
   */
  bookingEngagementChangedAt?: OffsetDateTime;
  /**
   *
   * @type {OffsetDateTime}
   * @memberof Company
   */
  bookingEngagementComputedAt?: OffsetDateTime;
  /**
   *
   * @type {BookingEngagement}
   * @memberof Company
   */
  bookingEngagementOverride?: BookingEngagement;
  /**
   *
   * @type {LocalDate}
   * @memberof Company
   */
  bookingEngagementOverrideUntil?: LocalDate;
  /**
   *
   * @type {string}
   * @memberof Company
   */
  bookingEngagementOverrideSetBy?: string;
  /**
   *
   * @type {OffsetDateTime}
   * @memberof Company
   */
  bookingEngagementOverrideSetAt?: OffsetDateTime;
  /**
   *
   * @type {string}
   * @memberof Company
   */
  bookingEngagementOverrideReason?: string;
  /**
   *
   * @type {OffsetDateTime}
   * @memberof Company
   */
  signupConversionFiredAt?: OffsetDateTime;
  /**
   *
   * @type {number}
   * @memberof Company
   */
  totalSettledCadSales?: number;
  /**
   *
   * @type {number}
   * @memberof Company
   */
  totalSettledCadProfit?: number;
  /**
   *
   * @type {string}
   * @memberof Company
   */
  customerSuccessAssignedTo?: string;
  /**
   *
   * @type {OffsetDateTime}
   * @memberof Company
   */
  customerSuccessAssignedAt?: OffsetDateTime;
  /**
   *
   * @type {string}
   * @memberof Company
   */
  salesPipelineEnteredStageNeverQuotedCs?: string;
  /**
   *
   * @type {string}
   * @memberof Company
   */
  salesPipelineEnteredStageQuotedNeverBookedCs?: string;
  /**
   *
   * @type {string}
   * @memberof Company
   */
  salesPipelineEnteredStageBooked1To4Cs?: string;
  /**
   *
   * @type {string}
   * @memberof Company
   */
  salesPipelineEnteredStageRegularShipperCs?: string;
  /**
   *
   * @type {string}
   * @memberof Company
   */
  ediId?: string;
  /**
   *
   * @type {string}
   * @memberof Company
   */
  oppref?: string;
  /**
   *
   * @type {string}
   * @memberof Company
   */
  cspOpportunityNarrative?: string;
  /**
   *
   * @type {boolean}
   * @memberof Company
   */
  apiRateLimitingEnabled?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof Company
   */
  sendReceiptOnLaterPayment?: boolean;
}

/**
 * Check if a given object implements the Company interface.
 */
export function instanceOfCompany(value: object): value is Company {
  return true;
}

export function CompanyFromJSON(json: any): Company {
  return CompanyFromJSONTyped(json, false);
}

export function CompanyFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): Company {
  if (json == null) {
    return json;
  }
  return {
    companyId: json["companyId"] == null ? undefined : json["companyId"],
    createdAt: json["createdAt"] == null ? undefined : json["createdAt"],
    companyName: json["companyName"] == null ? undefined : json["companyName"],
    stripeCustomerId:
      json["stripeCustomerId"] == null ? undefined : json["stripeCustomerId"],
    addCreditCardAuthorizationId:
      json["addCreditCardAuthorizationId"] == null
        ? undefined
        : json["addCreditCardAuthorizationId"],
    discountPercentage:
      json["discountPercentage"] == null
        ? undefined
        : json["discountPercentage"],
    forTest: json["forTest"] == null ? undefined : json["forTest"],
    preferredBrokerNorthbound:
      json["preferredBrokerNorthbound"] == null
        ? undefined
        : json["preferredBrokerNorthbound"],
    preferredBrokerSouthbound:
      json["preferredBrokerSouthbound"] == null
        ? undefined
        : json["preferredBrokerSouthbound"],
    defaultPickupLocation:
      json["defaultPickupLocation"] == null
        ? undefined
        : json["defaultPickupLocation"],
    defaultDeliveryLocation:
      json["defaultDeliveryLocation"] == null
        ? undefined
        : json["defaultDeliveryLocation"],
    utmSource: json["utmSource"] == null ? undefined : json["utmSource"],
    utmMedium: json["utmMedium"] == null ? undefined : json["utmMedium"],
    utmCampaignId:
      json["utmCampaignId"] == null ? undefined : json["utmCampaignId"],
    shipmentFrequency:
      json["shipmentFrequency"] == null ? undefined : json["shipmentFrequency"],
    quotingDisabled:
      json["quotingDisabled"] == null ? undefined : json["quotingDisabled"],
    paymentTermsDays:
      json["paymentTermsDays"] == null ? undefined : json["paymentTermsDays"],
    leadSource: json["leadSource"] == null ? undefined : json["leadSource"],
    temperature:
      json["temperature"] == null
        ? undefined
        : CompanyTemperatureFromJSON(json["temperature"]),
    creditLimit: json["creditLimit"] == null ? undefined : json["creditLimit"],
    referralCode:
      json["referralCode"] == null ? undefined : json["referralCode"],
    chequePaymentMethodPermitted:
      json["chequePaymentMethodPermitted"] == null
        ? undefined
        : json["chequePaymentMethodPermitted"],
    wirePaymentMethodPermitted:
      json["wirePaymentMethodPermitted"] == null
        ? undefined
        : json["wirePaymentMethodPermitted"],
    quotesRan: json["quotesRan"] == null ? undefined : json["quotesRan"],
    lastQuotedDate:
      json["lastQuotedDate"] == null ? undefined : json["lastQuotedDate"],
    shipmentsBooked:
      json["shipmentsBooked"] == null ? undefined : json["shipmentsBooked"],
    lastBookedDate:
      json["lastBookedDate"] == null ? undefined : json["lastBookedDate"],
    winRate: json["winRate"] == null ? undefined : json["winRate"],
    totalCadSales:
      json["totalCadSales"] == null ? undefined : json["totalCadSales"],
    fixedMarkup: json["fixedMarkup"] == null ? undefined : json["fixedMarkup"],
    doNotAutochargeOverdueInvoices:
      json["doNotAutochargeOverdueInvoices"] == null
        ? undefined
        : json["doNotAutochargeOverdueInvoices"],
    needsVerification:
      json["needsVerification"] == null ? undefined : json["needsVerification"],
    verificationDenied:
      json["verificationDenied"] == null
        ? undefined
        : json["verificationDenied"],
    currency:
      json["currency"] == null
        ? undefined
        : CurrencyCodeFromJSON(json["currency"]),
    isPersonal: json["isPersonal"] == null ? undefined : json["isPersonal"],
    phone: json["phone"] == null ? undefined : json["phone"],
    billingLatitude:
      json["billingLatitude"] == null ? undefined : json["billingLatitude"],
    billingLongitude:
      json["billingLongitude"] == null ? undefined : json["billingLongitude"],
    billingAddressLine:
      json["billingAddressLine"] == null
        ? undefined
        : json["billingAddressLine"],
    billingCity: json["billingCity"] == null ? undefined : json["billingCity"],
    billingState:
      json["billingState"] == null ? undefined : json["billingState"],
    billingPostalCode:
      json["billingPostalCode"] == null ? undefined : json["billingPostalCode"],
    defaultSalesContactId:
      json["defaultSalesContactId"] == null
        ? undefined
        : json["defaultSalesContactId"],
    billingCountry:
      json["billingCountry"] == null
        ? undefined
        : CountryCodeFromJSON(json["billingCountry"]),
    lastSignificantSalesCallDate:
      json["lastSignificantSalesCallDate"] == null
        ? undefined
        : json["lastSignificantSalesCallDate"],
    lastSalesCallDate:
      json["lastSalesCallDate"] == null ? undefined : json["lastSalesCallDate"],
    controlsLtlFreight:
      json["controlsLtlFreight"] == null
        ? undefined
        : ControlsLtlFreightFromJSON(json["controlsLtlFreight"]),
    snoozeSalesCallsUntil:
      json["snoozeSalesCallsUntil"] == null
        ? undefined
        : json["snoozeSalesCallsUntil"],
    associatedProfessionalDomain:
      json["associatedProfessionalDomain"] == null
        ? undefined
        : json["associatedProfessionalDomain"],
    hasNonProfessionalDomain:
      json["hasNonProfessionalDomain"] == null
        ? undefined
        : json["hasNonProfessionalDomain"],
    knownGroupEmailAddresses:
      json["knownGroupEmailAddresses"] == null
        ? undefined
        : json["knownGroupEmailAddresses"],
    referralCompanyId:
      json["referralCompanyId"] == null ? undefined : json["referralCompanyId"],
    referralShipmentId:
      json["referralShipmentId"] == null
        ? undefined
        : json["referralShipmentId"],
    firstQuoteDate:
      json["firstQuoteDate"] == null ? undefined : json["firstQuoteDate"],
    isBroker: json["isBroker"] == null ? undefined : json["isBroker"],
    firstBookedDate:
      json["firstBookedDate"] == null ? undefined : json["firstBookedDate"],
    lastSignificantSalesCallBy:
      json["lastSignificantSalesCallBy"] == null
        ? undefined
        : json["lastSignificantSalesCallBy"],
    lastSalesCallBy:
      json["lastSalesCallBy"] == null ? undefined : json["lastSalesCallBy"],
    gclid: json["gclid"] == null ? undefined : json["gclid"],
    utmTerm: json["utmTerm"] == null ? undefined : json["utmTerm"],
    invoiceAuditNotes:
      json["invoiceAuditNotes"] == null ? undefined : json["invoiceAuditNotes"],
    apiAccessEnabled:
      json["apiAccessEnabled"] == null ? undefined : json["apiAccessEnabled"],
    numberOfSalesCalls:
      json["numberOfSalesCalls"] == null
        ? undefined
        : json["numberOfSalesCalls"],
    numberOfSignificantSalesCalls:
      json["numberOfSignificantSalesCalls"] == null
        ? undefined
        : json["numberOfSignificantSalesCalls"],
    shipmentFrequencyOnSignup:
      json["shipmentFrequencyOnSignup"] == null
        ? undefined
        : json["shipmentFrequencyOnSignup"],
    totalOverdueIssuedInvoices:
      json["totalOverdueIssuedInvoices"] == null
        ? undefined
        : json["totalOverdueIssuedInvoices"],
    totalIssuedInvoices:
      json["totalIssuedInvoices"] == null
        ? undefined
        : json["totalIssuedInvoices"],
    totalDisputedInvoices:
      json["totalDisputedInvoices"] == null
        ? undefined
        : json["totalDisputedInvoices"],
    totalSettlementPendingInvoices:
      json["totalSettlementPendingInvoices"] == null
        ? undefined
        : json["totalSettlementPendingInvoices"],
    utmContent: json["utmContent"] == null ? undefined : json["utmContent"],
    utmCampaignName:
      json["utmCampaignName"] == null ? undefined : json["utmCampaignName"],
    msclkid: json["msclkid"] == null ? undefined : json["msclkid"],
    preferredPaymentMethod:
      json["preferredPaymentMethod"] == null
        ? undefined
        : PaymentMethodFromJSON(json["preferredPaymentMethod"]),
    preferredPaymentMethodNotes:
      json["preferredPaymentMethodNotes"] == null
        ? undefined
        : json["preferredPaymentMethodNotes"],
    totalCadProfit:
      json["totalCadProfit"] == null ? undefined : json["totalCadProfit"],
    averageQuoteQualityScore:
      json["averageQuoteQualityScore"] == null
        ? undefined
        : json["averageQuoteQualityScore"],
    networkId: json["networkId"] == null ? undefined : json["networkId"],
    lastClaimDate:
      json["lastClaimDate"] == null ? undefined : json["lastClaimDate"],
    numberClaimShipments:
      json["numberClaimShipments"] == null
        ? undefined
        : json["numberClaimShipments"],
    lastAdditionalChargeDate:
      json["lastAdditionalChargeDate"] == null
        ? undefined
        : json["lastAdditionalChargeDate"],
    numberAdditionalChargeShipments:
      json["numberAdditionalChargeShipments"] == null
        ? undefined
        : json["numberAdditionalChargeShipments"],
    numberInvoiceAuditProblemShipments:
      json["numberInvoiceAuditProblemShipments"] == null
        ? undefined
        : json["numberInvoiceAuditProblemShipments"],
    customerSpecificPricingEnabled:
      json["customerSpecificPricingEnabled"] == null
        ? undefined
        : json["customerSpecificPricingEnabled"],
    leadSourceNote:
      json["leadSourceNote"] == null ? undefined : json["leadSourceNote"],
    assignedTo: json["assignedTo"] == null ? undefined : json["assignedTo"],
    assignedAt: json["assignedAt"] == null ? undefined : json["assignedAt"],
    currentSalesPipelineStage:
      json["currentSalesPipelineStage"] == null
        ? undefined
        : SalesPipelineStageFromJSON(json["currentSalesPipelineStage"]),
    salesPipelineEnteredStageNeverQuotedAt:
      json["salesPipelineEnteredStageNeverQuotedAt"] == null
        ? undefined
        : json["salesPipelineEnteredStageNeverQuotedAt"],
    salesPipelineEnteredStageQuotedNeverBookedAt:
      json["salesPipelineEnteredStageQuotedNeverBookedAt"] == null
        ? undefined
        : json["salesPipelineEnteredStageQuotedNeverBookedAt"],
    salesPipelineEnteredStageBooked1To4At:
      json["salesPipelineEnteredStageBooked_1To_4At"] == null
        ? undefined
        : json["salesPipelineEnteredStageBooked_1To_4At"],
    salesPipelineEnteredStageRegularShipperAt:
      json["salesPipelineEnteredStageRegularShipperAt"] == null
        ? undefined
        : json["salesPipelineEnteredStageRegularShipperAt"],
    estimatedMonthlyFreightSpend:
      json["estimatedMonthlyFreightSpend"] == null
        ? undefined
        : json["estimatedMonthlyFreightSpend"],
    overdueCall: json["overdueCall"] == null ? undefined : json["overdueCall"],
    monthlyLtlCaptureEstimate:
      json["monthlyLtlCaptureEstimate"] == null
        ? undefined
        : json["monthlyLtlCaptureEstimate"],
    salesPipelineEnteredStageNeverQuotedAssignedTo:
      json["salesPipelineEnteredStageNeverQuotedAssignedTo"] == null
        ? undefined
        : json["salesPipelineEnteredStageNeverQuotedAssignedTo"],
    salesPipelineEnteredStageQuotedNeverBookedAssignedTo:
      json["salesPipelineEnteredStageQuotedNeverBookedAssignedTo"] == null
        ? undefined
        : json["salesPipelineEnteredStageQuotedNeverBookedAssignedTo"],
    salesPipelineEnteredStageBooked1To4AssignedTo:
      json["salesPipelineEnteredStageBooked_1To_4AssignedTo"] == null
        ? undefined
        : json["salesPipelineEnteredStageBooked_1To_4AssignedTo"],
    salesPipelineEnteredStageRegularShipperAssignedTo:
      json["salesPipelineEnteredStageRegularShipperAssignedTo"] == null
        ? undefined
        : json["salesPipelineEnteredStageRegularShipperAssignedTo"],
    additionalChargeGracePeriodDaysOverride:
      json["additionalChargeGracePeriodDaysOverride"] == null
        ? undefined
        : json["additionalChargeGracePeriodDaysOverride"],
    xeroContactId:
      json["xeroContactId"] == null ? undefined : json["xeroContactId"],
    bannerMessageTitle:
      json["bannerMessageTitle"] == null
        ? undefined
        : json["bannerMessageTitle"],
    bannerMessageDescription:
      json["bannerMessageDescription"] == null
        ? undefined
        : json["bannerMessageDescription"],
    bannerMessageLastEditedBy:
      json["bannerMessageLastEditedBy"] == null
        ? undefined
        : json["bannerMessageLastEditedBy"],
    bannerMessageLastEditedAt:
      json["bannerMessageLastEditedAt"] == null
        ? undefined
        : json["bannerMessageLastEditedAt"],
    estimatedMonthlyShipments:
      json["estimatedMonthlyShipments"] == null
        ? undefined
        : json["estimatedMonthlyShipments"],
    shipmentFrequencyNote:
      json["shipmentFrequencyNote"] == null
        ? undefined
        : json["shipmentFrequencyNote"],
    cspProposalEmailDraft:
      json["cspProposalEmailDraft"] == null
        ? undefined
        : json["cspProposalEmailDraft"],
    referrer: json["referrer"] == null ? undefined : json["referrer"],
    landingPage: json["landingPage"] == null ? undefined : json["landingPage"],
    firstTouchReferrer:
      json["firstTouchReferrer"] == null
        ? undefined
        : json["firstTouchReferrer"],
    firstTouchLandingPage:
      json["firstTouchLandingPage"] == null
        ? undefined
        : json["firstTouchLandingPage"],
    currentBookingEngagement:
      json["currentBookingEngagement"] == null
        ? undefined
        : BookingEngagementFromJSON(json["currentBookingEngagement"]),
    bookingAvgGapDays:
      json["bookingAvgGapDays"] == null ? undefined : json["bookingAvgGapDays"],
    daysSinceLastBooking:
      json["daysSinceLastBooking"] == null
        ? undefined
        : json["daysSinceLastBooking"],
    bookingOverdueRatio:
      json["bookingOverdueRatio"] == null
        ? undefined
        : json["bookingOverdueRatio"],
    bookingEngagementChangedAt:
      json["bookingEngagementChangedAt"] == null
        ? undefined
        : json["bookingEngagementChangedAt"],
    bookingEngagementComputedAt:
      json["bookingEngagementComputedAt"] == null
        ? undefined
        : json["bookingEngagementComputedAt"],
    bookingEngagementOverride:
      json["bookingEngagementOverride"] == null
        ? undefined
        : BookingEngagementFromJSON(json["bookingEngagementOverride"]),
    bookingEngagementOverrideUntil:
      json["bookingEngagementOverrideUntil"] == null
        ? undefined
        : json["bookingEngagementOverrideUntil"],
    bookingEngagementOverrideSetBy:
      json["bookingEngagementOverrideSetBy"] == null
        ? undefined
        : json["bookingEngagementOverrideSetBy"],
    bookingEngagementOverrideSetAt:
      json["bookingEngagementOverrideSetAt"] == null
        ? undefined
        : json["bookingEngagementOverrideSetAt"],
    bookingEngagementOverrideReason:
      json["bookingEngagementOverrideReason"] == null
        ? undefined
        : json["bookingEngagementOverrideReason"],
    signupConversionFiredAt:
      json["signupConversionFiredAt"] == null
        ? undefined
        : json["signupConversionFiredAt"],
    totalSettledCadSales:
      json["totalSettledCadSales"] == null
        ? undefined
        : json["totalSettledCadSales"],
    totalSettledCadProfit:
      json["totalSettledCadProfit"] == null
        ? undefined
        : json["totalSettledCadProfit"],
    customerSuccessAssignedTo:
      json["customerSuccessAssignedTo"] == null
        ? undefined
        : json["customerSuccessAssignedTo"],
    customerSuccessAssignedAt:
      json["customerSuccessAssignedAt"] == null
        ? undefined
        : json["customerSuccessAssignedAt"],
    salesPipelineEnteredStageNeverQuotedCs:
      json["salesPipelineEnteredStageNeverQuotedCs"] == null
        ? undefined
        : json["salesPipelineEnteredStageNeverQuotedCs"],
    salesPipelineEnteredStageQuotedNeverBookedCs:
      json["salesPipelineEnteredStageQuotedNeverBookedCs"] == null
        ? undefined
        : json["salesPipelineEnteredStageQuotedNeverBookedCs"],
    salesPipelineEnteredStageBooked1To4Cs:
      json["salesPipelineEnteredStageBooked_1To_4Cs"] == null
        ? undefined
        : json["salesPipelineEnteredStageBooked_1To_4Cs"],
    salesPipelineEnteredStageRegularShipperCs:
      json["salesPipelineEnteredStageRegularShipperCs"] == null
        ? undefined
        : json["salesPipelineEnteredStageRegularShipperCs"],
    ediId: json["ediId"] == null ? undefined : json["ediId"],
    oppref: json["oppref"] == null ? undefined : json["oppref"],
    cspOpportunityNarrative:
      json["cspOpportunityNarrative"] == null
        ? undefined
        : json["cspOpportunityNarrative"],
    apiRateLimitingEnabled:
      json["apiRateLimitingEnabled"] == null
        ? undefined
        : json["apiRateLimitingEnabled"],
    sendReceiptOnLaterPayment:
      json["sendReceiptOnLaterPayment"] == null
        ? undefined
        : json["sendReceiptOnLaterPayment"],
  };
}

export function CompanyToJSON(json: any): Company {
  return CompanyToJSONTyped(json, false);
}

export function CompanyToJSONTyped(
  value?: Company | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    companyId: value["companyId"],
    createdAt: value["createdAt"],
    companyName: value["companyName"],
    stripeCustomerId: value["stripeCustomerId"],
    addCreditCardAuthorizationId: value["addCreditCardAuthorizationId"],
    discountPercentage: value["discountPercentage"],
    forTest: value["forTest"],
    preferredBrokerNorthbound: value["preferredBrokerNorthbound"],
    preferredBrokerSouthbound: value["preferredBrokerSouthbound"],
    defaultPickupLocation: value["defaultPickupLocation"],
    defaultDeliveryLocation: value["defaultDeliveryLocation"],
    utmSource: value["utmSource"],
    utmMedium: value["utmMedium"],
    utmCampaignId: value["utmCampaignId"],
    shipmentFrequency: value["shipmentFrequency"],
    quotingDisabled: value["quotingDisabled"],
    paymentTermsDays: value["paymentTermsDays"],
    leadSource: value["leadSource"],
    temperature: CompanyTemperatureToJSON(value["temperature"]),
    creditLimit: value["creditLimit"],
    referralCode: value["referralCode"],
    chequePaymentMethodPermitted: value["chequePaymentMethodPermitted"],
    wirePaymentMethodPermitted: value["wirePaymentMethodPermitted"],
    quotesRan: value["quotesRan"],
    lastQuotedDate: value["lastQuotedDate"],
    shipmentsBooked: value["shipmentsBooked"],
    lastBookedDate: value["lastBookedDate"],
    winRate: value["winRate"],
    totalCadSales: value["totalCadSales"],
    fixedMarkup: value["fixedMarkup"],
    doNotAutochargeOverdueInvoices: value["doNotAutochargeOverdueInvoices"],
    needsVerification: value["needsVerification"],
    verificationDenied: value["verificationDenied"],
    currency: CurrencyCodeToJSON(value["currency"]),
    isPersonal: value["isPersonal"],
    phone: value["phone"],
    billingLatitude: value["billingLatitude"],
    billingLongitude: value["billingLongitude"],
    billingAddressLine: value["billingAddressLine"],
    billingCity: value["billingCity"],
    billingState: value["billingState"],
    billingPostalCode: value["billingPostalCode"],
    defaultSalesContactId: value["defaultSalesContactId"],
    billingCountry: CountryCodeToJSON(value["billingCountry"]),
    lastSignificantSalesCallDate: value["lastSignificantSalesCallDate"],
    lastSalesCallDate: value["lastSalesCallDate"],
    controlsLtlFreight: ControlsLtlFreightToJSON(value["controlsLtlFreight"]),
    snoozeSalesCallsUntil: value["snoozeSalesCallsUntil"],
    associatedProfessionalDomain: value["associatedProfessionalDomain"],
    hasNonProfessionalDomain: value["hasNonProfessionalDomain"],
    knownGroupEmailAddresses: value["knownGroupEmailAddresses"],
    referralCompanyId: value["referralCompanyId"],
    referralShipmentId: value["referralShipmentId"],
    firstQuoteDate: value["firstQuoteDate"],
    isBroker: value["isBroker"],
    firstBookedDate: value["firstBookedDate"],
    lastSignificantSalesCallBy: value["lastSignificantSalesCallBy"],
    lastSalesCallBy: value["lastSalesCallBy"],
    gclid: value["gclid"],
    utmTerm: value["utmTerm"],
    invoiceAuditNotes: value["invoiceAuditNotes"],
    apiAccessEnabled: value["apiAccessEnabled"],
    numberOfSalesCalls: value["numberOfSalesCalls"],
    numberOfSignificantSalesCalls: value["numberOfSignificantSalesCalls"],
    shipmentFrequencyOnSignup: value["shipmentFrequencyOnSignup"],
    totalOverdueIssuedInvoices: value["totalOverdueIssuedInvoices"],
    totalIssuedInvoices: value["totalIssuedInvoices"],
    totalDisputedInvoices: value["totalDisputedInvoices"],
    totalSettlementPendingInvoices: value["totalSettlementPendingInvoices"],
    utmContent: value["utmContent"],
    utmCampaignName: value["utmCampaignName"],
    msclkid: value["msclkid"],
    preferredPaymentMethod: PaymentMethodToJSON(
      value["preferredPaymentMethod"],
    ),
    preferredPaymentMethodNotes: value["preferredPaymentMethodNotes"],
    totalCadProfit: value["totalCadProfit"],
    averageQuoteQualityScore: value["averageQuoteQualityScore"],
    networkId: value["networkId"],
    lastClaimDate: value["lastClaimDate"],
    numberClaimShipments: value["numberClaimShipments"],
    lastAdditionalChargeDate: value["lastAdditionalChargeDate"],
    numberAdditionalChargeShipments: value["numberAdditionalChargeShipments"],
    numberInvoiceAuditProblemShipments:
      value["numberInvoiceAuditProblemShipments"],
    customerSpecificPricingEnabled: value["customerSpecificPricingEnabled"],
    leadSourceNote: value["leadSourceNote"],
    assignedTo: value["assignedTo"],
    assignedAt: value["assignedAt"],
    currentSalesPipelineStage: SalesPipelineStageToJSON(
      value["currentSalesPipelineStage"],
    ),
    salesPipelineEnteredStageNeverQuotedAt:
      value["salesPipelineEnteredStageNeverQuotedAt"],
    salesPipelineEnteredStageQuotedNeverBookedAt:
      value["salesPipelineEnteredStageQuotedNeverBookedAt"],
    salesPipelineEnteredStageBooked_1To_4At:
      value["salesPipelineEnteredStageBooked1To4At"],
    salesPipelineEnteredStageRegularShipperAt:
      value["salesPipelineEnteredStageRegularShipperAt"],
    estimatedMonthlyFreightSpend: value["estimatedMonthlyFreightSpend"],
    overdueCall: value["overdueCall"],
    monthlyLtlCaptureEstimate: value["monthlyLtlCaptureEstimate"],
    salesPipelineEnteredStageNeverQuotedAssignedTo:
      value["salesPipelineEnteredStageNeverQuotedAssignedTo"],
    salesPipelineEnteredStageQuotedNeverBookedAssignedTo:
      value["salesPipelineEnteredStageQuotedNeverBookedAssignedTo"],
    salesPipelineEnteredStageBooked_1To_4AssignedTo:
      value["salesPipelineEnteredStageBooked1To4AssignedTo"],
    salesPipelineEnteredStageRegularShipperAssignedTo:
      value["salesPipelineEnteredStageRegularShipperAssignedTo"],
    additionalChargeGracePeriodDaysOverride:
      value["additionalChargeGracePeriodDaysOverride"],
    xeroContactId: value["xeroContactId"],
    bannerMessageTitle: value["bannerMessageTitle"],
    bannerMessageDescription: value["bannerMessageDescription"],
    bannerMessageLastEditedBy: value["bannerMessageLastEditedBy"],
    bannerMessageLastEditedAt: value["bannerMessageLastEditedAt"],
    estimatedMonthlyShipments: value["estimatedMonthlyShipments"],
    shipmentFrequencyNote: value["shipmentFrequencyNote"],
    cspProposalEmailDraft: value["cspProposalEmailDraft"],
    referrer: value["referrer"],
    landingPage: value["landingPage"],
    firstTouchReferrer: value["firstTouchReferrer"],
    firstTouchLandingPage: value["firstTouchLandingPage"],
    currentBookingEngagement: BookingEngagementToJSON(
      value["currentBookingEngagement"],
    ),
    bookingAvgGapDays: value["bookingAvgGapDays"],
    daysSinceLastBooking: value["daysSinceLastBooking"],
    bookingOverdueRatio: value["bookingOverdueRatio"],
    bookingEngagementChangedAt: value["bookingEngagementChangedAt"],
    bookingEngagementComputedAt: value["bookingEngagementComputedAt"],
    bookingEngagementOverride: BookingEngagementToJSON(
      value["bookingEngagementOverride"],
    ),
    bookingEngagementOverrideUntil: value["bookingEngagementOverrideUntil"],
    bookingEngagementOverrideSetBy: value["bookingEngagementOverrideSetBy"],
    bookingEngagementOverrideSetAt: value["bookingEngagementOverrideSetAt"],
    bookingEngagementOverrideReason: value["bookingEngagementOverrideReason"],
    signupConversionFiredAt: value["signupConversionFiredAt"],
    totalSettledCadSales: value["totalSettledCadSales"],
    totalSettledCadProfit: value["totalSettledCadProfit"],
    customerSuccessAssignedTo: value["customerSuccessAssignedTo"],
    customerSuccessAssignedAt: value["customerSuccessAssignedAt"],
    salesPipelineEnteredStageNeverQuotedCs:
      value["salesPipelineEnteredStageNeverQuotedCs"],
    salesPipelineEnteredStageQuotedNeverBookedCs:
      value["salesPipelineEnteredStageQuotedNeverBookedCs"],
    salesPipelineEnteredStageBooked_1To_4Cs:
      value["salesPipelineEnteredStageBooked1To4Cs"],
    salesPipelineEnteredStageRegularShipperCs:
      value["salesPipelineEnteredStageRegularShipperCs"],
    ediId: value["ediId"],
    oppref: value["oppref"],
    cspOpportunityNarrative: value["cspOpportunityNarrative"],
    apiRateLimitingEnabled: value["apiRateLimitingEnabled"],
    sendReceiptOnLaterPayment: value["sendReceiptOnLaterPayment"],
  };
}
